import { FC } from 'react'
import cn from 'classnames'

import useMessenger from '@/hooks/useMessenger'
import useDebounce from '@/hooks/useDebounce'
import { IAction, IMessage, IMessageItem, StringObject } from '@/context/types'
import { MESSAGE_TYPES } from '@/context/constants'

import '../styles.css'

interface CategoriesCarouselProps {
  message: IMessage
  isChatWidget: boolean
}

const CategoriesCarousel: FC<CategoriesCarouselProps> = ({
  message,
  isChatWidget,
}) => {
  const {
    isConversationNew,
    getUserObj,
    getSelectedConversation,
    getConfig,
    sendMessage,
  } = useMessenger()
  const userObj = getUserObj()

  const handleOnClick = (actions: IAction[], metadata: StringObject) => {
    if (actions.length === 0) {
      return
    }

    const { text, payload } = actions[0]

    const sendPayload = {
      type: MESSAGE_TYPES.MESSAGE,
      conversationId: getSelectedConversation(),
      author: {
        type: getConfig()?.userType,
        userExternalId: getConfig()?.userExternalId,
      },
      content: {
        type: 'text',
        text,
        payload,
      },
      metadata: {
        source: 'poplar-messenger',
        ...metadata,
      },
    }

    sendMessage(sendPayload)
  }

  return (
    <div>
      {!isChatWidget && (
        <>
          <div className="pmui-flex pmui-items-center">
            <div className="pmui-w-10 pmui-h-10 pmui-rounded-full pmui-flex pmui-justify-center pmui-items-center pmui-bg-slate-600 circle">
              <span className="icon icon-ic-poplar pmui-text-lg" />
            </div>
            <div className="sm:pmui-text-xs md:pmui-text-sm pmui-my-3 pmui-ml-2">
              Hi {`${userObj.firstName}`}! How can I help? 👋 Select a category
              to get started.
            </div>
          </div>
          <div className="horizontal-divider pmui-my-2" />
        </>
      )}
      <div className="carousel-container pmui-py-2 pmui-px-2">
        {message.content.items.map((item: IMessageItem) => (
          <button
            key={`${message.id}-${item.title}`}
            className={cn(
              'pmui-mr-4 pmui-w-36 pmui-h-36 pmui-text-center pmui-rounded-xl pmui-flex-shrink-0',
              {
                'pmui-cursor-pointer hover:pmui-bg-gray-100': isConversationNew,
              },
              { 'carousel-box': true },
            )}
            disabled={!isConversationNew}
            onClick={useDebounce(
              () => handleOnClick(item.actions, {}),
              getConfig()?.debounceTimeout,
            )}
          >
            <div className="pmui-flex pmui-justify-center pmui-w-full">
              <div className="pmui-p-3">
                <span
                  className={`pmui-text-4xl icon icon-${item?.metadata?.icon} pmui-text-pop-orange`}
                />
              </div>
            </div>
            <div className="pmui-text-base pmui-font-semibold ">
              {item.title}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default CategoriesCarousel
